import DigiobcanApi from '../../api/DigiobcanApi';
import { createQueryFn, QueryNameSpace } from '../../lib/query';
import type { QueryFunctionContext } from '@tanstack/react-query';

type Params = {
  reportId: string;
};

export const adminGetReportDetail = createQueryFn(
  QueryNameSpace.adminGetReportDetail,
  async ({ queryKey }: QueryFunctionContext<[string] | [string, Params]>) => {
    const [, params] = queryKey;
    const data = await DigiobcanApi.adminGetReportDetail(params.reportId);
    return data;
  },
);
